
@for (message of (messages$ | async); track message) {
  <div class="message mat-elevation-z2">
    <div [innerHTML]="message.message"></div>
  </div>
}
